export default function SectionApp() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12 bg-background-50 rounded-xl p-6 md:p-10">
          <div className="flex-shrink-0 w-32 h-32 md:w-40 md:h-40 rounded-2xl bg-primary-500 flex items-center justify-center">
            <i className="ri-smartphone-line text-5xl md:text-6xl text-white"></i>
          </div>
          <div className="flex-1 text-center md:text-left">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">
              随时随地，掌上吃瓜
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-5">
              下载吃瓜爆料官方APP，享受实时推送通知、夜间模式、离线阅读和个性化订阅等专属功能。iOS与安卓均已上架，扫码或点击下方按钮即刻下载，不错过任何一个新鲜大瓜。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center md:justify-start gap-3">
              <a
                href="#app"
                onClick={(e) => e.preventDefault()}
                className="whitespace-nowrap cursor-pointer px-6 py-2.5 bg-foreground-950 text-background-50 text-sm font-medium rounded-md hover:bg-foreground-800 transition-colors inline-flex items-center gap-2"
              >
                <i className="ri-apple-line"></i>
                App Store 下载
              </a>
              <a
                href="#app"
                onClick={(e) => e.preventDefault()}
                className="whitespace-nowrap cursor-pointer px-6 py-2.5 bg-accent-500 text-white text-sm font-medium rounded-md hover:bg-accent-600 transition-colors inline-flex items-center gap-2"
              >
                <i className="ri-android-line"></i>
                安卓版下载
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}